module.exports = __webpack_public_path__ + "media/images/form-builder-60aff800f029b29b2638e34360f61a90.svg";